import { render } from "./AITools.vue?vue&type=template&id=0a0b8fc6&scoped=true&ts=true"
import script from "./AITools.vue?vue&type=script&lang=ts"
export * from "./AITools.vue?vue&type=script&lang=ts"

import "./AITools.vue?vue&type=style&index=0&id=0a0b8fc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0b8fc6"]])

export default __exports__